import { render, staticRenderFns } from "./DiscussHistoryList.vue?vue&type=template&id=f7f58416&"
import script from "./DiscussHistoryList.vue?vue&type=script&lang=js&"
export * from "./DiscussHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports